import React from 'react';
import { Component } from 'react';
import "./LogInPage.scss";
import LogInScreen from '../../components/screens/LogIn/LogInScreen';

type LogInPageProps = {
};

export default class LogInPage extends Component<LogInPageProps> {
    public render() {
        return (
            <div>
                <div className="background"></div>
                <div className="web-container log-in">

                     <section id="log-in">
                        <LogInScreen/>
                    </section>

                </div>
            </div>
        )
    }
}